import React , {useState,useEffect} from 'react';
import { useParams } from 'react-router-dom';
import {useForm} from 'react-hook-form';
import clinicService from '../../../../../services/clinic.service'
import {toast} from 'react-toastify'

const TimeZoneCard = () => {
    const {clinicId} = useParams();
    const [isEditing,setIsEditing] = useState(false);
    const [isLoading,setIsLoading] = useState(false);
    const [timeZone,setTimeZone] = useState(null);
    const [timeZoneList,setTimeZoneList] = useState([]);
    const {register,handleSubmit} = useForm();

    useEffect(() => {
        setIsLoading(true);
        clinicService.getTimeZone(clinicId)
        .then(res=>{
            setTimeZone(res.data);
            setIsLoading(false)
        })
        .catch(err =>{
            setIsLoading(false)
            toast.error("Error while getting Timezone",{
                position:toast.POSITION.BOTTOM_RIGHT
               })
        })

        clinicService.getAllTimeZones()
        .then(res =>{
            setTimeZoneList(res.data)
        })
        .catch(err=>{
           toast.error("Error while getting All Timezone",{
            position:toast.POSITION.BOTTOM_RIGHT
           })
        })
    
      
    },[clinicId]);
    const onSubmit =(data)=>{
        
            clinicService.updateTimezone(clinicId,data)
            .then(res=>{
                
                toast.success("Updated Timezone",{
                    position:toast.POSITION.BOTTOM_RIGHT
                })
            })
            .catch(error=>{
                toast.error("Error WHile Updating ",{
                    position:toast.POSITION.BOTTOM_RIGHT
                })
                console.log("Error while updating Timezone")
            })
    }
    return ( 
        <>
         <div className="info-box card mt-4">
              <i className="bi bi-hourglass-split"></i>
              <div className="d-flex justify-content-between editClinic">
              <h3>TimeZone</h3>
              <div className="editButton" onClick={()=>setIsEditing(!isEditing)}>
                        <i className="bi bi-pencil-square"></i>
                    </div>
               </div>
              <div>
                  {isLoading ? <div className="loader">loading</div> :
                    isEditing? <div>
                        <form onSubmit={handleSubmit(onSubmit)}> 
                            <div className="form-group">
                                <select 
                                    className="form-select" 
                                    {...register("timezoneid")}
                                    >
                                    {timeZoneList.map(item => <option key={item.id} value={item.id} >{item.name}</option>)}
                                   
                                </select>
                            </div>
                            <div className="d-flex justify-content-between">
                                <button className="btn btn-secondary btn-sm mt-2" type="submit">Save</button>
                                 <button className="btn btn-light btn-sm mt-2" type="button" onClick={()=>setIsEditing(!isEditing)}>Cancel</button>
                        
                            </div>
                        
                        </form>
                       
                    </div>: <p>{timeZone && timeZone.name}</p>
                  }
              </div>
        </div>
        </>
     );
}
 
export default TimeZoneCard;